// extracted by mini-css-extract-plugin
export default {"Header":"zyklo_Header__lXH5d","container":"zyklo_container__bDQCC","navbtn":"zyklo_navbtn__q+sW2"};